import dynamic from 'next/dynamic';
import { BulletinBoardProps } from './BulletinBoard.types';

export const BulletinBoard = dynamic<{ model: BulletinBoardProps }>(() =>
  import('./BulletinBoard').then(mod => mod.BulletinBoard)
);
